import React, { useState } from 'react';
import { logStepResponse } from '../../../utils/experimentLog';

// 各問の X-1（PartSelect）の【次に進む】。部品プルダウン・ヒントと同じ行に置く。
// X-1 では自由記述をさせない（2026-10-14週例：演習でテストと同じ自由記述をすると
// 「練習したからポストでできた」と言われかねないため）。記録するのは着色した部品だけ。
// 部品が選ばれていれば（「△わからない」も可）押せ、確認ダイアログを挟まず onAdvance で進む。
// locked: 回答済みの問へタブで戻ってきたとき。選んだ部品は見せたまま、ボタンだけ押せなくする。
function PartNextButton({ selectedPart, locked = false, onAdvance }) {
  const [submitting, setSubmitting] = useState(false);
  const canSubmit = !locked && Boolean(selectedPart);

  const handleClick = () => {
    if (!canSubmit || submitting) return;
    setSubmitting(true);
    // 送れなかった分は端末のキューに残して再送する（演習は止めない）
    logStepResponse({ selectedPart, selfExplanation: null, answerMode: null, templateUsed: false, prompt: null });
    if (typeof onAdvance === 'function') onAdvance('', { text: '', selections: null });
  };

  return (
    <button
      type="button"
      className={`btn-sheet part-next${canSubmit && !submitting ? ' btn-sheet--attention' : ''}`}
      disabled={!canSubmit || submitting}
      onClick={handleClick}
    >
      <span className="step-badge">2</span>
      {locked ? '回答済み' : '次に進む'}
    </button>
  );
}

export default PartNextButton;
